import React from 'react';
import classnames from 'classnames';
import { injectIntl, IntlShape } from 'react-intl';
import { IReportListItemDTO, ReportStatus, ReportType } from '../../../../../api/reports.dao';
import DefaultButton from '../../../../global/default-button/default-button';
import Text from '../../../../global/text/text';
import { reportStatusLabels, reportTypeLabels } from '../../../../../constants/report-labels.constants';
import { getReportDateTimeString } from '../../../../../infrastructure/utils/date.util';
import { editText, openText } from '../../../../../constants/common-labels.constants';

interface IProps extends IReportListItemDTO {
    intl: IntlShape;
    handleOpen: () => void;
    eventTimezone: string;
    canEditReport: boolean;
    onEditReport: () => void;
    isSelected: boolean;
}

const ReportListItem = injectIntl((props: IProps) => {
    const {
        intl,
        uploadDateTime,
        alias,
        assetType,
        uploadedBy,
        status,
        handleOpen,
        eventTimezone,
        canEditReport,
        onEditReport,
        isSelected
    } = props;

    const cellEffectClasses = classnames({
        'active': isSelected,
        'hoverable': !isSelected,
    });

    const reportTypeLabel = intl.formatMessage(reportTypeLabels[assetType] || reportTypeLabels[ReportType.EVENT_REPORT]);

    return (
        <tr className='reports-list-item' onDoubleClick={handleOpen}>
            <Text className={cellEffectClasses} tag='td' message={getReportDateTimeString(uploadDateTime, eventTimezone)} withEllipsis />
            <td className={classnames(cellEffectClasses)}>
                <div className={classnames({
                    'reports-list-item__name-with-edit': canEditReport
                })}>
                    <Text message={alias} withEllipsis />
                    { canEditReport && status !== ReportStatus.PENDING &&
                        <DefaultButton
                            className='visible-while-hovered'
                            modifier={['slim', 'link']}
                            text={editText()}
                            onClick={onEditReport}
                        />
                    }
                </div>
            </td>
            <Text className={cellEffectClasses} tag='td' message={reportTypeLabel} withEllipsis />
            <Text className={cellEffectClasses} tag='td' message={uploadedBy} withEllipsis />
            <Text className={cellEffectClasses} tag='td' message={intl.formatMessage(reportStatusLabels[status])} withEllipsis />
            <td className={classnames(cellEffectClasses, 'align-right')}>
                { status !== ReportStatus.PENDING && <DefaultButton
                    modifier='slim'
                    onClick={handleOpen}
                    className='visible-while-hovered'
                    text={openText()}
                /> }
            </td>
        </tr>
    );
});

export { ReportListItem };
